import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

export interface RegistrarCierreRequest {
  usuarioCierre: string;
  idMotivoCierre: number;
  observaciones: string | null;
  esExitosa: 'N';
}

export interface CierreData {
  idCierre: number;
  idCotizacion: number;
  fechaCierre: string;
  usuarioCierre: string;
  esExitosa: string;
  idMotivoCierre: number;
  observaciones: string | null;
  idTipoCotizacion: number;
  nombreTipoCotizacion: string;
  estadoCotizacion: number;
}

export interface RegistrarCierreResponse {
  success: boolean;
  message: string;
  code: string;
  data: CierreData;
  error: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class CierreCotizacionService {
  private readonly baseUrl = `${ENV.HOST}${URL_MAP.API.COTIZADOR_VENTA_GANADA}`;

  constructor(private httpClient: HttpClient) {}

  registrarCierre(
    idCotizacion: number,
    body: RegistrarCierreRequest
  ): Observable<RegistrarCierreResponse> {
    return this.httpClient
      .post<RegistrarCierreResponse>(`${this.baseUrl}/${idCotizacion}/cierre`, body)
      .pipe(
        catchError(error => {
          console.error('Error en registrarCierre:', error);
          return throwError(() => error);
        })
      );
  }

  consultarCierre(idCotizacion: number): Observable<RegistrarCierreResponse> {
    return this.httpClient
      .get<RegistrarCierreResponse>(`${this.baseUrl}/${idCotizacion}/cierre`)
      .pipe(
        catchError(error => {
          console.error('Error en consultarCierre:', error);
          return throwError(() => error);
        })
      );
  }
}
